import { Component, OnInit } from '@angular/core';
import { WorkflowService } from '../../../data-access/workflow.service';
import { buildTaskSummaryLines, buildCaseSummaryLines, buildReadOnlyReviewLines, TaskSummaryLine, EMPTY_TASKS_MESSAGE } from './apr-landing-utils';

@Component({
  selector: 'apr-landing',
  templateUrl: './apr-landing.component.html',
  styleUrls: ['./apr-landing.component.scss'],
})
export class AprLandingComponent implements OnInit {
  // Case-summary line(s) first, then task lines — merged once on load so the
  // template binds a stable array (no per-change-detection allocation).
  summaryLines: TaskSummaryLine[] = [];
  loading = true;
  loadError = false;
  readonly emptyMessage = EMPTY_TASKS_MESSAGE;

  constructor(private workflowSvc: WorkflowService) {}

  get isEmpty(): boolean {
    return this.summaryLines.length === 0;
  }

  trackByKey(_: number, line: TaskSummaryLine): string {
    return line.key;
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.loadError = false;
    try {
      const [cases, tasks, readOnlyReviews] = await Promise.all([
        this.workflowSvc.getMyCases(),
        this.workflowSvc.getMyTasks(),
        this.workflowSvc.getReadOnlyReviews(),
      ]);
      this.summaryLines = [
        ...buildCaseSummaryLines(cases),
        ...buildTaskSummaryLines(tasks),
        ...buildReadOnlyReviewLines(readOnlyReviews),
      ];
    } catch (err) {
      // Keep this distinct from the empty state — an empty list means "nothing to
      // do", a failed load must not be mistaken for that (a candidate could miss
      // a deadline). See the loadError branch in the template.
      console.error('Failed to load APR landing summary', err);
      this.summaryLines = [];
      this.loadError = true;
    } finally {
      this.loading = false;
    }
  }
}
